import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=178d4aa4&"
import script from "./Page.jsx?vue&type=script&lang=js&"
export * from "./Page.jsx?vue&type=script&lang=js&"
import style0 from "./Page.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports